<template>
    <form class="feedback" @submit.prevent="sendFeedback">
        <h2 class="page__title title title--m">Обратная связь</h2>
        <template v-if="!send">
            <div class="feedback__description">
                Здесь Вы можете направить своё обращение
            </div>
            <div class="feedback__items form__item">
                <label class="feedback__item">
                    <span class="form__label">ФИО отправителя</span>
                    <el-input class="input" v-model="feedback.name" required/>
                </label>
                <label class="feedback__item">
                    <span class="form__label">Город</span>
                    <el-input class="input" v-model="feedback.city"/>
                </label>
                <label class="feedback__item">
                    <span class="form__label">Контактный телефон</span>
                    <el-input class="input" v-model="feedback.phone"
                              v-mask="'+7 ### ### ## ##'" placeholder="+79999999999"
                              required/>
                </label>
                <label class="feedback__item">
                    <span class="form__label">E-mail адрес</span>
                    <el-input type="email" class="input" v-model="feedback.email" required/>
                </label>
                <div class="feedback__item">
                    <span class="form__label">Тема сообщения</span>
                    <el-select v-model="feedback.type"
                               placeholder="Выберите тему сообщения">
                        <el-option
                                v-for="item in themes"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <label class="form__item">
                <span class="form__label">Текст сообщения</span>
                <el-input type="textarea" class="input" :rows="windowWidth > 992 ? 4 : 6" v-model="feedback.description" required/>
            </label>
            <div class="form__item form__item--big-m">
                <el-checkbox v-model="agreement" label="Настоящим я даю согласие на обработку моих персональных данных в соответствии с формой" />
                <a href="#" class="feedback__link">Согласия на обработку персональных данных</a>
                <a href="#" class="feedback__link">Положением об обработке персональных данных</a>
            </div>
            <div class="form__item form__item--center">
                <button class="btn btn--middle btn--main feedback__button"
                        :disabled="!agreement"
                        type="submit">
                    Отправить
                </button>
            </div>
        </template>
        <div class="feedback__description" v-else>
            Ваше обращение успешно отправлено!
        </div>
    </form>
</template>

<script>
    import {mask} from "vue-the-mask";
    import ApiService from "../../../../js/modules/ApiService";

    export default {
        name: "Feedback",
        directives: {mask},
        data: () => ({
            feedback: {
                name: '',
                phone: '',
                email: '',
                type: 1,
                description: '',
                city: ''
            },
            agreement: false,
            themes: [],
            send: false,
        }),
        methods: {
            sendFeedback() {
                new ApiService().post('/send-feedback', this.feedback)
                    .then((response) => {
                        this.send = true;
                    });
            },
        },
        mounted() {
            new ApiService().get('/all-feedback-themes')
                .then((response) => {
                    this.themes = response.data;
                });
        }
    }
</script>

<style>
    .feedback__button:disabled {
        opacity: 0.5;
    }
</style>
